import { WorkingHoursContractRepository } from "@/modules/working_hours/domain/WorkingHoursContractRepository";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher_get, sync_command_dispatcher } from "@/api/client";
import store from "@/store";

export class ApiWorkingHoursContractRepository implements WorkingHoursContractRepository {
  command_dispatcher: CommandDispatcher;
  query_dispatcher: QueryDispatcher;

  constructor() {
    this.command_dispatcher = sync_command_dispatcher;
    this.query_dispatcher = query_dispatcher_get;
  }

  async check_user_working_hours_active_contract(user_id: number, company_id: number): Promise<{has_active: boolean, has_expired_trial: boolean, has_expired_trial_company: boolean}> {
    const cachedCompanyId = store.getters.workingHoursFlagsCompanyId;
    if (cachedCompanyId !== null && Number(cachedCompanyId) === Number(company_id)) {
      return {
        has_active: store.getters.hasWorkingHoursContract || false,
        has_expired_trial: store.getters.hasExpiredTrialWorkingHours || false,
        has_expired_trial_company: store.getters.hasExpiredTrialCompanyWorkingHours || false,
      };
    }
    let res = await this.query_dispatcher.dispatch('check.user.has.active.working.hours.contract', { user_id: user_id, company_id: company_id });
    return {
      has_active: res.company || false,
      has_expired_trial: res.has_expired_trial || false,
      has_expired_trial_company: res.has_expired_trial_company || false
    };
  }

  async activate_trial_working_hours_contract(user_id: number, company_id: number, product_code: string, kind: string): Promise<boolean> {
    let res = await this.command_dispatcher.dispatch('activate.user.trial.working.hours', { user_id: user_id, company_id: company_id });

    let output = res;

    if (res && res.job_id && res.output) {
      output = res.output;
    }

    if (output && output.data === 'ok') {
      return true;
    } else {
      if (output && output.error) {
        console.error('[TRIAL ERROR]', output.error);
      } else if (output && output.data === 'failed' && output.error) {
        console.error('[TRIAL ERROR]', output.error);
      } else {
        console.error('[TRIAL ERROR] Unknown error format:', output);
      }
      return false;
    }
  }
}